// extracted by mini-css-extract-plugin
export default {"main_css_US":"Header_main_css_US__+-MpC","main_css_JP":"Header_main_css_JP__asoga","logo_css_US":"Header_logo_css_US__AT3OU","logo_css_JP":"Header_logo_css_JP__WRutK"};